/* eslint-disable arrow-body-style */
import React, { useState } from 'react';
import getConfig from 'next/config';
import moment from 'moment';

import NewContentModal from '../components/NewContentModal/NewContentModal';

import { getGenericStorageItem, setGenericStorageItem, StorageType } from '../lib/storage';
import { dateIsInRange } from '../lib/dates';

const LOCAL_STORAGE_STATUS_KEY = 'Inspiretec.NewContentModalStatuses';

const { ENVIRONMENT } = getConfig().publicRuntimeConfig;

const withNewContentModal = (contentKey) => (WrappedComponent) => {
  const WrappedPortalComponent = (props) => {
    const newContentModalStatuses =
      getGenericStorageItem(LOCAL_STORAGE_STATUS_KEY, StorageType.LOCAL_STORAGE);
    const parsedModalStatuses = JSON.parse(newContentModalStatuses ?? '{}');
    const hasUserDismissedModal = !!parsedModalStatuses?.[contentKey];

    const {
      start: publishStart,
      end: publishEnd,
    } = ENVIRONMENT.NewContentModals?.[contentKey] ?? {};

    const shouldBeVisible = dateIsInRange(moment(), [publishStart, publishEnd]);

    const [isModalOpen, setIsModalOpen] = useState(!hasUserDismissedModal && shouldBeVisible);

    const handleModalClose = () => {
      const updatedModalStatuses = {
        ...parsedModalStatuses,
        [contentKey]: true,
      };
      setGenericStorageItem(
        LOCAL_STORAGE_STATUS_KEY,
        JSON.stringify(updatedModalStatuses),
        StorageType.LOCAL_STORAGE,
      );
      setIsModalOpen(false);
    };

    return (
      <>
        <NewContentModal
          contentKey={contentKey}
          active={isModalOpen}
          onClose={handleModalClose}
        />
        <WrappedComponent {...props} />
      </>
    );
  };

  return WrappedPortalComponent;
};

export default withNewContentModal;
